
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Dialog} from "primereact";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";

import AgGrid from "../../../../Components/Tables/AgGrid/AgGrid";
import { getLabel } from "../../../../Services/Language/LanguageService";
import { baseLang } from "../../../../Lang/BaseLang";
import { ConfigContext } from "../../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Services/ToastService";

import { RolesConAcceso, UsuariosConAcceso } from "../../../../API/IT/Accesos/AccesosRequests"; 
import { EliminarAcceso } from "../../../../API/IT/Users/UserRequests";

const AccesosUser = ({ showDialogUser, setShowDialogUser, selected}) => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [userAccess, setUserAccess] = useState([]);
  const [rolAccess, setRolAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  


  const hideDialog = () => {
    setShowDialogUser(false);
  };

  const getInfo = async () => {
    setLoading(true);
    const result = await UsuariosConAcceso(selected?.IdAccess);
    setUserAccess(result);
    const resultado = await RolesConAcceso(selected?.IdAccess);
    setRolAccess(resultado);
    setLoading(false);
  };

  useEffect(() => {
    getInfo();
  }, [showDialogUser]);


  const columns = [
    {
      header: 'ID',
      headerEn:'ID',
      field: 'IdUser',
      className: 'Xsmall',
      hidden: userAuth?.IdRol === 1
    },
    {
      header: 'Nombre Usuario',
      headerEn:'User Name',
      field: 'UserName',
    },
    {
      header: 'Nombre Usuario',
      headerEn:'User Name',
      field: 'UserName',
    },
    {
      header: 'Rol',
      headerEn:'Rol',
      field: 'Rol',
    },
    {
      header: 'Código Personal',
      headerEn:'Personal Code',
      field: 'IdPersonal',
    },
    {
      field: "IdUser",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-trash",
          tooltip: "Eliminar",
          onClick: async (rowData) => {

            let IdUser = rowData?.IdUser
            let IdAccess = selected?.IdAccess

            const resp = await EliminarAcceso(IdUser, IdAccess)
            toastShow(toast, 'success', 'Eliminado', "Acceso eliminado al usuario.")
            getInfo()
          },
          tooltipOptions: { position: "right"},
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: userAccess,
    loading: loading,
  };


  const columnsRoles = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdRol",
      className: "Xsmall",
    },
    {
      header: "Rol",
      headerEn: "Role",
      field: "Rol",
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "Description",
    },
  ];

  const tableRoles = {
    Columns: columnsRoles,
    Data: rolAccess,
    loading: loading,
  };

  return (
    <div>
      <Dialog
        visible={showDialogUser}
        style={{ width: "50vw", height: "65vh" }}
        onHide={hideDialog}
        header={
          <div>
            {getLabel(baseLang, "userAccess", config.language)}{" "}
            {selected?.Access}
          </div>
        }
      >
        <Toast ref={toast} />
        <TabView>
          <TabPanel header="Usuarios con Acceso">
            <div className="d-flex mt-2 mb-2 gap-2">
              <Button icon="pi pi-refresh" onClick={getInfo} />
              <Button icon="pi pi-plus" onClick={getInfo} tooltip="Agregar Usuario"/>
            </div>
            <div style={{ height: "45vh" }}>
              <AgGrid table={table} />
            </div>
          </TabPanel>
          <TabPanel header="Roles con Acceso">
            <div className="d-flex mt-2 mb-2 gap-2">
              <Button icon="pi pi-refresh" onClick={getInfo} />
              <Button icon="pi pi-plus" onClick={getInfo} tooltip="Agregar Usuario"/>
            </div>
            <div style={{ height: "45vh" }}>
              <AgGrid table={tableRoles} />
            </div>
          </TabPanel>
        </TabView>
      </Dialog>
    </div>
  );
};


export default AccesosUser;
